import { render, staticRenderFns } from "./AuthOrganisationRequested.vue?vue&type=template&id=031d5dd4&scoped=true"
import script from "./AuthOrganisationRequested.vue?vue&type=script&lang=js"
export * from "./AuthOrganisationRequested.vue?vue&type=script&lang=js"
import style0 from "./AuthOrganisationRequested.vue?vue&type=style&index=0&id=031d5dd4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "031d5dd4",
  null
  
)

export default component.exports